import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chenggong",
  "use": "icon-chenggong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chenggong\"><path d=\"M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z\" /><path d=\"M300.492014 432.812302m24.135912 24.135912l163.882839 163.882839q24.135911 24.135911 0 48.271823l-4.766843 4.766842q-24.135911 24.135911-48.271823 0l-163.882839-163.882839q-24.135911-24.135911 0-48.271823l4.766843-4.766842q24.135911-24.135911 48.271823 0Z\" fill=\"#FFFFFF\" /><path d=\"M768.74937 385.847384m-24.135911 24.135911l-258.736971 258.736971q-24.135911 24.135911-48.271823 0l-4.766843-4.766842q-24.135911-24.135911 0-48.271823l258.736971-258.736971q24.135911-24.135911 48.271823 0l4.766843 4.766843q24.135911 24.135911 0 48.271822Z\" fill=\"#FFFFFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chenggong.svg
// module id = OdZf
// module chunks = 16